import React from 'react';

interface BasicInfoFieldsProps {
  name: string;
  description: string;
  errors: {
    name?: string;
    description?: string;
  };
  onChange: (field: 'name' | 'description', value: string) => void;
}

const fieldBase =
  'mt-1 block w-full bg-white border rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 transition-colors';

const BasicInfoFields: React.FC<BasicInfoFieldsProps> = ({
  name,
  description,
  errors,
  onChange
}) => {
  return (
    <>
      <div className="col-span-2">
        <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
          Nome do Produto *
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onChange('name', e.target.value)}
          className={`${fieldBase} ${
            errors.name
              ? 'border-bordo/60 focus:ring-bordo/40 focus:border-bordo'
              : 'border-tinta/15 focus:ring-bordo/40 focus:border-bordo'
          }`}
          placeholder="Ex: iPhone 14"
        />
        {errors.name && (
          <p className="mt-1 text-sm text-bordo italic">{errors.name}</p>
        )}
      </div>

      <div className="col-span-2">
        <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
          Descrição
        </label>
        <textarea
          value={description}
          onChange={(e) => onChange('description', e.target.value)}
          rows={3}
          className={`${fieldBase} resize-y ${
            errors.description
              ? 'border-bordo/60 focus:ring-bordo/40 focus:border-bordo'
              : 'border-tinta/15 focus:ring-bordo/40 focus:border-bordo'
          }`}
          placeholder="Descreva o produto..."
        />
        {errors.description && (
          <p className="mt-1 text-sm text-bordo italic">{errors.description}</p>
        )}
      </div>
    </>
  );
};

export default BasicInfoFields;
